var _a;
import SetLinkModal from '../../components/SetLinkModal/SetLinkModal';
var Modals = {
    TEXT_LINK: 'text-link',
};
var ModalsMap = (_a = {},
    _a[Modals.TEXT_LINK] = SetLinkModal,
    _a);
export { Modals, ModalsMap };
//# sourceMappingURL=modals.js.map